import { render, staticRenderFns } from "./ModulesPanel.vue?vue&type=template&id=477132a7&"
import script from "./ModulesPanel.vue?vue&type=script&lang=js&"
export * from "./ModulesPanel.vue?vue&type=script&lang=js&"
import style0 from "./modules-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports